module.exports = __webpack_public_path__ + "img/complete-step.d9714a30.svg";